import React from "react";

import { colors } from "./theme";

export default function TextInput({
  label,
  placeholder = "",
  value = "",
  onChange,
  type = "text",
  fullWidth = false,
  disabled = false,
  error = "",
  helperText = "",
  required = false,
  autoFocus = false,
  style = {},
  ...props
}) {
  return (
    <div
      style={{
        width: fullWidth ? "100%" : "auto",
        display: "flex",
        flexDirection: "column",
        gap: 6
      }}
    >
      {label && (
        <label
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: colors.text
          }}
        >
          {label}
          {required && (
            <span style={{ color: colors.danger }}> *</span>
          )}
        </label>
      )}

      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        autoFocus={autoFocus}
        style={{
          width: "100%",
          padding: "12px 14px",
          borderRadius: 10,
          border: `1px solid ${
            error ? colors.danger : colors.border
          }`,
          background: disabled
            ? colors.surfaceMuted
            : colors.surface,
          color: colors.text,
          fontSize: 15,
          outline: "none",
          transition: "all 0.2s ease",
          boxSizing: "border-box",
          ...style
        }}
        onFocus={(e) => {
          e.target.style.border = `1px solid ${colors.primary}`;
          e.target.style.boxShadow = `0 0 0 3px ${colors.primaryLight}`;
        }}
        onBlur={(e) => {
          e.target.style.border = `1px solid ${
            error ? colors.danger : colors.border
          }`;
          e.target.style.boxShadow = "none";
        }}
        {...props}
      />

      {error ? (
        <span
          style={{
            color: colors.danger,
            fontSize: 12
          }}
        >
          {error}
        </span>
      ) : helperText ? (
        <span
          style={{
            color: colors.textMuted,
            fontSize: 12
          }}
        >
          {helperText}
        </span>
      ) : null}
    </div>
  );
}